// extracted by mini-css-extract-plugin
export default {"imagemCabecalho":"ConteudoEmail_imagemCabecalho__72uEs","imagem":"ConteudoEmail_imagem__Fkdrl"};